import { Select, Form, Popover } from "antd";
import { useProductStore } from './LayoutProducto';
import { Col, Row } from "antd";
import items from "../../api/cuentaAux.json";

const { Option } = Select;

export const ContableItems = () => {
  const producto = useProductStore();
  const listItems = typesProduct;

  function fixEncoding(str = "") {
    return str.replace(/Ã\?/g, 'Ñ');
  }

  function renderLabel(item) {
    const text = `${item.id} - Parametrización contable para ${item.value}`;
    return (
      <Popover content={`${item.id} - Parametrización ${item.value}`} placement="top">
        <span>
          {text.length > 150 ? `${text.substring(0, 20)}...` : text}
        </span>
      </Popover>
    );
  }

  const groupedItems = listItems.reduce((acc, item, index) => {
    if (index % 2 === 0) acc.push([]);
    acc[acc.length - 1].push(item);
    return acc;
  }, []);

  return groupedItems.map((row, rowIndex) => (
    <Row key={rowIndex} gutter={[24, 16]} style={{ marginLeft: "-12px", marginRight: "-12px" }}>
      {row.map((i, colIndex) => (
        <Col key={colIndex} xs={24} lg={12}>
          <Form.Item
            name={`cat${rowIndex * 2 + colIndex}`}
            label={renderLabel(i)}
            rules={[
              {
                required: true,
                message: "Selecciona una categoría contable",
              },
            ]}
            tooltip={`Cuenta contable para ${i.value}.`}
          >
            <Select
              onChange={(value) => producto.setCategory(rowIndex * 2 + colIndex, value)}
              placeholder="Selecciona una categoría contable"
              allowClear
              showSearch
              style={{ width: "100%" }}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
              }
            >
              {items.map((category) => (
                <Option key={category.SubCuentAuxiliarNumero} value={category.SubCuentAuxiliarNumero}>
                  {`${category.SubCuentAuxiliarNumero} - ${fixEncoding(category.SubCuentaAuxiliarNombre)}`}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      ))}
    </Row>
  ));
};

// Definición de categorías
const typesProduct = [
  { id: 0, value: "Inventario" },
  { id: 1, value: "Ventas" },
  { id: 2, value: "Costo de Ventas" },
  { id: 4, value: "Devolución Compras" },
  { id: 5, value: "Devolución Ventas" },
];
